/* Buscar una pantalla en el menú (ticket 384, Nico 13/10: «Agregame un
 * buscador a la barra de menú. Buscar scroleando es una paja»).
 *
 * El menú tiene más de cien pantallas en una columna de 250px. Esto no busca
 * datos —para eso está el buscador de arriba—: busca PANTALLAS, por cómo se
 * llaman, en qué grupo están o de qué sector son.
 *
 * Busca en el nombre, el corto, el `alias`, el grupo y el sector; NO en el
 * `sub` (ése lo mira el buscador de arriba).
 *
 * Todo lo que se escribe tiene que estar: «pañol puerto» encuentra el pañol
 * del puerto y no todos los pañoles. Sin acentos ni mayúsculas, y por pedazo
 * de palabra («herr» encuentra Herramientas). */

import { normalizar } from "../../shared/buscar";

const palabras = (t) => normalizar(t).split(/\s+/).filter(Boolean);

/* `alias`: cómo se la busca además de por su nombre —por ejemplo, cómo se
 * llamaba antes—. El 20/10 «Proveedores» del Pañol pasó a llamarse «Talleres
 * y servicios» y quien escribía «proveedor» acá se quedaba con «Nada con ese
 * nombre»: este casillero NO mira el `sub` (es largo y traería de más). El
 * alias cuenta para encontrarla y no para el orden, que sigue siendo el del
 * nombre. Puede ser un texto o una lista. */
export const aliasDe = (item) => [].concat(item.alias || []);

/* Qué tan arriba va: primero las que EMPIEZAN así, después las que lo tienen
 * en el nombre, y al final las que sólo coinciden por el grupo o el sector. */
function peso(item, qs) {
  const nombre = normalizar(item.label);
  if (qs.every((q) => nombre.startsWith(q) || nombre.split(/\s+/).some((p) => p.startsWith(q)))) {
    return nombre.startsWith(qs[0]) ? 0 : 1;
  }
  return qs.every((q) => nombre.includes(q)) ? 2 : 3;
}

/* `grupos` es lo que ya dibuja el menú: sólo lo que la persona puede abrir.
 * Devuelve las pantallas que coinciden, cada una con su sector. Las que
 * todavía no están hechas no se ofrecen: no hay adónde ir. */
export function buscarEnMenu(grupos, texto) {
  const qs = palabras(texto);
  if (qs.length === 0) return [];
  const out = [];
  let orden = 0;
  for (const g of grupos || []) {
    for (const item of g.items || []) {
      orden += 1;
      if (item.donde === "pronto") continue;
      const donde = normalizar(
        [item.label, item.corto, ...aliasDe(item), g.grupo, g.universo]
          .filter(Boolean).join(" "));
      if (!qs.every((q) => donde.includes(q))) continue;
      out.push({ item, universo: g.universo, grupo: g.grupo, peso: peso(item, qs), orden });
    }
  }
  return out.sort((a, b) => a.peso - b.peso || a.orden - b.orden);
}

/* A dónde lleva una entrada del menú. El mismo criterio que el rail. */
export const destinoDe = (item) =>
  item.donde === "flotabot" ? `/panel/${item.id}` : item.ruta;
